import Info from './Info.view';
export default Info;
